export type KPIAbsoluteComparison =
  | { kind: 'missingPreviousData' }
  | { kind: 'previousValueZero' }
  | { kind: 'noDifference' }
  | { kind: 'delta'; value: number };

type NonDeltaKPIAbsoluteComparison = Exclude<KPIAbsoluteComparison, { kind: 'delta' }>;

export const KPI_ABSOLUTE_COMPARISON_TOOLTIP_MESSAGES: Record<
  NonDeltaKPIAbsoluteComparison['kind'],
  string
> = {
  missingPreviousData: 'Not enough data for comparison',
  previousValueZero: 'No previous value (it was 0)',
  noDifference: 'No difference with the previous value',
};

export function getKPIAbsoluteComparison(
  current: number,
  previous: number | null
): KPIAbsoluteComparison {
  if (previous === null) {
    return { kind: 'missingPreviousData' };
  }

  if (previous === 0) {
    return { kind: 'previousValueZero' };
  }

  if (current === previous) {
    return { kind: 'noDifference' };
  }

  return { kind: 'delta', value: current - previous };
}
